import { Component, OnInit, ViewChild, ElementRef, Input, EventEmitter, Output, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { Picker } from '../picker';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { debounceTime, switchMap, distinctUntilChanged } from 'rxjs/operators';
import { SearchService } from '../../../../services/search.service';
import { log } from 'util';
import * as _ from 'lodash';

export interface Destination {
  hotel: string;
  resort: string;
  country: string;
}

@Component({
  selector: 'ts-destination-picker',
  templateUrl: './destination-picker.component.html',
  styleUrls: ['./destination-picker.component.scss', '../../style.scss']
})

export class DestinationPickerComponent extends Picker implements OnInit, OnChanges {

  @ViewChild('searchInput') searchInput: ElementRef;
  @ViewChild('searchResultsWrapper') searchResultsWrapper: ElementRef;
  @ViewChild('searchResultsList') searchResultsListElement: ElementRef;
  @ViewChild('searchInputWrapper') searchInputWrapper: ElementRef;
  @Input() baseURL: any[];
  @Input() destinations: any[];
  @Input() departureAirports: any[];
  @Input() isDestinationsLoading: Boolean = true;
  @Input() searchedDestinations: any[];
  @Input() selectedDestination: string;
  @Output() destinationSelected = new EventEmitter();
  @Output() enterClicked = new EventEmitter();

  resorts: any[];
  countries: any[];
  searchFormControl = new FormControl('');
  previousSearchValue = '';

  isTyping = false;
  isDestination: Boolean = false;
  isHoverDisabled: Boolean = false;
  searchedDestinationFocusIndex: number = null;
  destination: string;

  withRefresh = false;
  hotelSearchResults$: Observable<any[]>;
  private hotelSearchText$ = new Subject<string>();
  searchTerm: FormControl = new FormControl();
  myBooks = <any>[];
  constructor(private searchService: SearchService) {
    super();
  }


  ngOnInit() {
    this.searchTerm.valueChanges.subscribe(
      term => {
        if (!term) {
          this.reset();
          return;
        }
        this.isTyping = true;
        this.searchedDestinations = [];
        let _destinations = [...this.destinations];
        let result = _.filter(_destinations, (destination: any) => {
          if (destination.name.toLowerCase().includes(term.toLowerCase()) || destination.country.toLowerCase().includes(term.toLowerCase())) {
            return destination;
          }
        });
        if (result.length > 0) {
          this.searchedDestinations = this.searchedDestinations.concat(result);
        }
        if (term !== '' && term.length > 4) {
          this.searchService.searchHotels(term, this.departureAirports).subscribe(
            data => {
              if (data.length <= 100) {
                this.searchedDestinations = this.searchedDestinations.concat(data);
              }
            });
        }
      });
    this.setupHotelSearch();
    this.initDestinations();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedDestination) {
      this.destination = this.selectedDestination;
    }
    if (changes.destinations) {
      this.initDestinations();
    }
  }

  initDestinations() {
    this.destination = this.selectedDestination;
    this.searchedDestinations = [...this.destinations];
    // this.searchedDestinations.unshift({
    //   name: 'Anywhere',
    //   type: 'anywhere',
    //   resort: 'Anywhere',
    //   region: 'Anywhere',
    //   country: 'Anywhere',
    //   label: 'Anywhere'
    // });
  }
  private setupHotelSearch() {
    this.hotelSearchResults$ = this.hotelSearchText$.pipe(
      debounceTime(400), distinctUntilChanged(),
      switchMap((packageName) =>
        this.searchService.getHotels(packageName, this.departureAirports, this.baseURL))
    );
    this.hotelSearchResults$.subscribe(countries => {
      const hotels = this.flattenDestinationsByHotels(countries);
      this.searchedDestinations.push(...hotels);
    });
  }

  private flattenDestinationsByHotels(countries) {
    let hotels = [];
    for (let i = 0; i < countries.length; i++) {
      const country = countries[i];
      for (let j = 0; j < country.regions.length; j++) {
        const region = country.regions[j];
        for (let k = 0; k < region.resorts.length; k++) {
          const resort = region.resorts[k];
          for (let l = 0; l < resort.hotels.length; l++) {
            const hotel = resort.hotels[l];
            let hotelObj = {
              name: hotel,
              type: 'hotel',
              resort: resort.name,
              region: region.name,
              country: country.name,
              label: hotel
            };
            if (resort.name) {
              hotelObj.label = hotelObj.label + ', ' + resort.name;
            }
            if (region.name) {
              if (!resort.name || resort.name !== region.name) {
                hotelObj.label = hotelObj.label + ', ' + region.name;
              }
            }
            if (country.name) {
              hotelObj.label = hotelObj.label + ', ' + country.name;
            }
            hotels.push(hotelObj);
          }
        }
      }
    }
    return hotels;
  }

  incrementSearchedHotelsFocusIndex() {
    if (this.searchedDestinations.length > 0) {
      if (this.searchedDestinationFocusIndex === null) {
        this.setNextDestinationFocusInDropdown();
      } else {
        if (this.searchedDestinationFocusIndex < this.searchedDestinations.length - 1) {
          this.setNextDestinationFocusInDropdown();
        }
      }
    }
  }

  decrementSearcedHotelsFocusIndex() {
    if (this.searchedDestinations.length > 0) {
      if (this.searchedDestinationFocusIndex === null) {
        this.setPreviousDestinationFocusInDropdown();
      } else {
        if (this.searchedDestinationFocusIndex > 0) {
          this.setPreviousDestinationFocusInDropdown();
        }
      }
    }
  }

  private setNextDestinationFocusInDropdown() {
    let index = 1;
    // if (this.searchedDestinations[0].type === 'anywhere') {
    //   index = 1;
    // } else {
    //   index = 0;
    // }
    if (this.searchedDestinationFocusIndex === null) {
      index = 0;
    }

    let nextDestinationInDropdown = this.searchedDestinations[this.searchedDestinationFocusIndex + index];
    if (!this.isTyping) {
      while (nextDestinationInDropdown && (nextDestinationInDropdown.type === 'resort')) {
        index = index + 1;
        nextDestinationInDropdown = this.searchedDestinations[this.searchedDestinationFocusIndex + index];
      }
    }

    if (nextDestinationInDropdown !== null || nextDestinationInDropdown !== undefined) {
      this.searchedDestinationFocusIndex = this.searchedDestinationFocusIndex + index;
    }
  }

  private setPreviousDestinationFocusInDropdown() {
    let index = 1;
    let previousDestinationInDropdown = this.searchedDestinations[this.searchedDestinationFocusIndex - index];
    if (!this.isTyping) {
      while (previousDestinationInDropdown && (previousDestinationInDropdown.type === 'resort')) {
        index = index + 1;
        previousDestinationInDropdown = this.searchedDestinations[this.searchedDestinationFocusIndex - index];
      }
    }
    if (previousDestinationInDropdown !== null || previousDestinationInDropdown !== undefined) {
      this.searchedDestinationFocusIndex = this.searchedDestinationFocusIndex - index;
    } else if (!previousDestinationInDropdown) {
      // If there is nothing to select, clear focus
      this.searchedDestinationFocusIndex = null;
      if (this.searchResultsListElement) {
        requestAnimationFrame(() => this.scrollToPosition(this.searchResultsListElement.nativeElement, 0, 'up'));
      }
    }
  }

  preventInputCaretMovement(event?: KeyboardEvent) {
    if (event && (event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 13)) {
      event.preventDefault();
    }
  }

  search(event?: KeyboardEvent) {
    if (event && (event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 13)) {
      event.preventDefault();
      this.disableHover();
      // this.showDropdown = true;
    }
    if (event && event.keyCode === 40) {
      // If ArrowDown pressed
      if (this.searchedDestinationFocusIndex !== this.searchedDestinations.length - 1) {
        this.incrementSearchedHotelsFocusIndex();
        this.scrollToFocusedHotelItem('down');
      }
    } else if (event && event.keyCode === 38) {
      // If ArrowUp pressed
      if (this.searchedDestinationFocusIndex === null || this.searchedDestinationFocusIndex === 0) {
        this.searchedDestinationFocusIndex = null;
        this.searchInput.nativeElement.focus();
      } else {
        this.decrementSearcedHotelsFocusIndex();
        this.scrollToFocusedHotelItem('up');
      }
    } else if (event && event.keyCode === 13 && this.searchedDestinationFocusIndex !== null) {
      if (this.searchedDestinations[this.searchedDestinationFocusIndex].type === 'hotel') {
        this.onHotelClicked(this.searchedDestinations[this.searchedDestinationFocusIndex].name, 'hotel');
      } else {
        this.onDestinationClicked(this.searchedDestinations[this.searchedDestinationFocusIndex]);
      }
    }
  }

  sortSearch(value) {
    let searchedDestinations = [];
    let _destinations = [...this.destinations];
    _destinations.forEach(destination => {
      if (destination.type === 'region' || destination.type === 'resort' || destination.type === 'country') {
        if (destination.name.toLowerCase().includes(value.toLowerCase()) || destination.country.toLowerCase().includes(value.toLowerCase())) {
          searchedDestinations.push(destination);
        }
      }
    });
    if (this.searchFormControl.value.length >= 4) {
      this.hotelSearchText$.next(this.searchFormControl.value);
    }
    this.searchedDestinations = searchedDestinations;
  }

  onSelect() {
  }

  focus() {
    this.searchedDestinationFocusIndex = null;
  }

  enableHover() {
    this.isHoverDisabled = false;
  }

  disableHover() {
    this.isHoverDisabled = true;
  }

  setSearchedDestinationsFocusIndex(destination) {
    this.searchedDestinationFocusIndex = destination;
  }

  onMouseLeave() {
    this.enableHover();
    this.setSearchedDestinationsFocusIndex(null);
  }

  scrollToFocusedHotelItem(direction: 'up' | 'down') {
    setTimeout(() => {
      let searchResultsListElement = this.searchResultsListElement ? this.searchResultsListElement.nativeElement : null;
      if (!searchResultsListElement) {
        return;
      }
      // Get the focused hotel item
      const focusedHotelItem = searchResultsListElement.getElementsByClassName('focused') ? searchResultsListElement.getElementsByClassName('focused')[0] : null;
      if (focusedHotelItem) {
        const searchResultsWrapperElement = this.searchResultsWrapper.nativeElement;
        const searchResultsWrapperHeight = searchResultsWrapperElement.offsetHeight || searchResultsWrapperElement.clientHeight || searchResultsWrapperElement.scrollHeight;

        const scrollViewRangeTop = searchResultsWrapperElement.scrollTop;
        const scrollViewRangeBottom = searchResultsWrapperElement.scrollTop + searchResultsWrapperHeight;

        const focusedHotelItemBottomPosition = focusedHotelItem.offsetTop + focusedHotelItem.offsetHeight;
        const isFocusedHotelItemInView = (focusedHotelItem.offsetTop >= scrollViewRangeTop) && (focusedHotelItem.offsetTop < scrollViewRangeBottom) && (focusedHotelItemBottomPosition >= scrollViewRangeTop) && (focusedHotelItemBottomPosition < scrollViewRangeBottom);
        if (!isFocusedHotelItemInView) {
          /**
           * If the focusedHotelItem is not in view, determine where list should be scrolled to
           */
          let scrollToPositionValue = 0;
          if (this.searchedDestinationFocusIndex === this.searchedDestinations.length - 1) {
            // If focusedHotelItem is the last item, scroll to the max point
            const maxScrollHeight = searchResultsWrapperElement.scrollHeight - (searchResultsWrapperElement.offsetHeight || searchResultsWrapperElement.clientHeight);
            scrollToPositionValue = maxScrollHeight;
          } else if (this.searchedDestinationFocusIndex === 0) {
            // If focusedHotelItem is the first item, scroll to the beginning
            scrollToPositionValue = 0;
          } else {
            // Else scroll based on the focusedHotelItem's size (height)
            scrollToPositionValue = direction === 'down' ? Math.ceil(searchResultsWrapperElement.scrollTop + focusedHotelItem.offsetHeight) : Math.floor(searchResultsWrapperElement.scrollTop - focusedHotelItem.offsetHeight);
            // If a header needs to be skipped then scroll further
            if (direction === 'down' && focusedHotelItem.previousElementSibling && focusedHotelItem.previousElementSibling.classList.contains('result-item-heading')) {
              scrollToPositionValue = Math.ceil(scrollToPositionValue + focusedHotelItem.previousElementSibling.offsetHeight) + 10;
            } else if (direction === 'up' && focusedHotelItem.nextElementSibling && focusedHotelItem.nextElementSibling.classList.contains('result-item-heading')) {
              scrollToPositionValue = Math.floor(scrollToPositionValue - focusedHotelItem.nextElementSibling.offsetHeight) - 10;
              if (scrollToPositionValue < 0) {
                scrollToPositionValue = 0;
              }
            }
          }
          requestAnimationFrame(() => this.scrollToPosition(searchResultsWrapperElement, scrollToPositionValue, direction));
        }
      }
    });
  }

  scrollToPosition(scrollContainerElement, position: number, direction: 'up' | 'down') {
    const scrollSpeed = 9;
    if (direction === 'down') {
      if ((scrollContainerElement.scrollTop + scrollSpeed) < position) {
        scrollContainerElement.scrollTop = scrollContainerElement.scrollTop + scrollSpeed;
        if (scrollContainerElement.scrollTop < position) {
          requestAnimationFrame(() => this.scrollToPosition(scrollContainerElement, position, direction));
        } else {
          scrollContainerElement.scrollTop = position;
        }
      } else {
        scrollContainerElement.scrollTop = position;
      }
    } else {
      if ((scrollContainerElement.scrollTop - scrollSpeed) > position) {
        scrollContainerElement.scrollTop = scrollContainerElement.scrollTop - scrollSpeed;
        if (scrollContainerElement.scrollTop > position) {
          requestAnimationFrame(() => this.scrollToPosition(scrollContainerElement, position, direction));
        } else {
          scrollContainerElement.scrollTop = position;
        }
      } else {
        scrollContainerElement.scrollTop = position;
      }
    }
  }

  deselectDestination() {
    this.destination = '';
    this.clear();
    setTimeout(() => this.isDestination = true);
  }

  clear() {
    this.isTyping = false;
    this.searchFormControl.setValue('');
    this.reset();
  }

  onDestinationClicked(destination) {

    if (!destination) {
      return;
    }
    this.destination = destination.name;
    let event = {
      country: destination.country,
      name: destination.name,
      resorts: destination.resorts,
      type: destination.type
    };
    if (destination.type === 'resort') {
      event['region'] = destination.region;
      event.resorts = [];
    }
    this.searchFormControl.setValue(destination.name);
    this.destinationSelected.emit(event);
    this.isDestination = false;
  }

  onHotelClicked(hotel, type) {
    this.destination = hotel;
    let event = {
      name: hotel,
      type: type,
      resorts: [],
    };
    this.destinationSelected.emit(event);
    this.isDestination = false;
  }

  reset() {
    setTimeout(() => {
      this.isTyping = false;
      this.searchedDestinations = [...this.destinations];
      // this.searchedDestinations.unshift({
      //   name: 'Anywhere',
      //   type: 'anywhere',
      //   resort: 'Anywhere',
      //   region: 'Anywhere',
      //   country: 'Anywhere',
      //   label: 'Anywhere'
      // });
    });
  }

  dismissResultsPopover() {
    if (!this.destination) {
      this.clear();
    }
    setTimeout(() => {
      this.isDestination = false;
    });
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    if (!this.searchResultsWrapper || !this.searchResultsWrapper.nativeElement || !this.searchInput) {
      return;
    }
    const clickedInside = this.searchResultsWrapper.nativeElement.contains(targetElement) || this.searchInput.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.dismissResultsPopover();
    }
  }
}
